import css from 'styled-jsx/css';

const styles = css.global`.blog-description h3 {
  /* max-width: 302px; */
  color: #222222;
  font-family: 'SantanderHeadline';
  font-size: 18px;
  letter-spacing: 0;
  line-height: 24px;
  text-align: left;

  margin: 24px 0 32px 0;
  font-weight: 800;
}

@media (min-width: 992px) {
  .blog-description h3 {
    max-width: 757px;
    color: #222222;
    font-size: 24px;
    letter-spacing: 0;
    line-height: 36px;
    font-weight: 800;
  }
}
`;

export default styles;